module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/venue_shibuya-35798603d9e11572ab1b74ee44778d3f.jpg";